/**
 *
 * key
 *
 */


const key = 'ZWNGb2xsb3d1cA=='

export default key